import { useState, useCallback } from 'react';

const useModal = (initialState = false) => {
  const [open, setOpen] = useState(initialState);

  const openModal = useCallback(() => {
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
  }, []);

  const toggle = useCallback((state?: boolean) => {
    if (state !== undefined) {
      setOpen(state);
    } else {
      setOpen(prev => !prev);
    }
  }, []);

  return {
    open,
    openModal,
    closeModal,
    toggle,
  };
};

export default useModal;
